import React from 'react';

import { Modal } from 'semantic-ui-react';
import {spacings} from 'style';

const style = {
    modal: {
        paddingLeft: spacings.large,
        paddingRight: spacings.large,
        paddingBottom: spacings.tiny,
    }
}

const SurveyPageModal = ({surveyPage, children, onClose}) => (
    <Modal closeIcon open size="tiny" onClose={onClose} style={style.modal}>
        <Modal.Header>{surveyPage.title}</Modal.Header>
        {children}
    </Modal>
);

export default SurveyPageModal;



// WEBPACK FOOTER //
// ./src/modules/surveys/SurveyPageModal.js